import { DISABLED_MAINTENANCE } from '../actions/maintenance.actions'
const initialState = {
  isMaintenanceDisable: false,
}

export default function (state = initialState, action) {
  const newState = { ...state }
  switch (action.type) {
    case DISABLED_MAINTENANCE:
      return { ...newState, isMaintenanceDisable: action.value }
    default:
      return newState
  }
}
